/** @jsx jsx */

import { css, jsx } from "@emotion/react";
import { useNavigate } from "@gatsbyjs/reach-router";
import { Button, Icon, Link } from "@whitespace/components";
import { Loading } from "@whitespace/gatsby-theme-smorgasbord/src/components";
import { camelCase } from "lodash-es";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";

import { useCGIGRP2LoginStatus } from "../hooks";

import CGIGRP2LoginDialogError from "./CGIGRP2LoginDialogError";

// import * as styles from "./CGIGRP2LoginDialogProgress.module.css";

CGIGRP2LoginDialogProgress.propTypes = {
  onAbort: PropTypes.func,
  onFailure: PropTypes.func,
  onRetry: PropTypes.func,
  onSuccess: PropTypes.func,
  mode: PropTypes.oneOf(["same", "other"]),
};

export default function CGIGRP2LoginDialogProgress({
  onAbort,
  onFailure,
  onRetry,
  onSuccess,
  mode,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    // loading,
    error,
    grpFault,
    progressStatus: status,
    AutoStartToken: autostarttoken,
    qrCode,
  } = useCGIGRP2LoginStatus();

  // Handle error
  useEffect(() => {
    if (error && onFailure) {
      onFailure(error);
    }
  }, [error]);

  useEffect(() => {
    if (status === "COMPLETE" && onSuccess) {
      onSuccess(error);
    }
  }, [status]);

  if (grpFault) {
    return (
      <CGIGRP2LoginDialogError
        error={grpFault}
        onRetryClick={() => onRetry()}
      />
    );
  }
  if (status === "COMPLETE") {
    return (
      <Loading
        // text=""
        css={css`
          margin: auto;
        `}
      />
    );
  }
  return (
    <div
      css={css`
        text-align: center;
      `}
    >
      {autostarttoken && mode === "same" ? (
        <div
          css={css`
            display: grid;
            gap: 1rem;
            text-align: center;
          `}
        >
          <Loading
            text=""
            css={css`
              margin: auto;
            `}
          />
          <Button
            url={`bankid:///?autostarttoken=${autostarttoken}&redirect=null`}
          >
            {t("bankid.launchApp")}
            <Icon name="open" />
          </Button>
          <p>
            {t("bankid.switchToOtherDeviceDescr")}
            <br />
            <Link onClick={() => navigate("../other")}>
              {t("bankid.switchToOtherDevice")}
            </Link>
          </p>
          <p>
            <Link onClick={onAbort}>{t(`bankid.abort`)}</Link>
          </p>
        </div>
      ) : (
        <div
          css={css`
            display: grid;
            gap: 1rem;
            text-align: center;
          `}
        >
          {qrCode ? (
            <QRCode
              value={qrCode}
              css={css`
                margin: auto;
                max-width: 100%;
              `}
            />
          ) : (
            <Loading
              text=""
              css={css`
                margin: auto;
              `}
            />
          )}
          <p>
            {t([
              `bankid.status.${(status && camelCase(status)) || "unknown"}`,
              `bankid.status.unknown`,
            ])}
          </p>
          <p>
            {t("bankid.switchToSameDeviceDescr")}
            <br />
            <Link onClick={() => navigate("../same")}>
              {t("bankid.switchToSameDevice")}
            </Link>
          </p>
          <p>
            <Link onClick={onAbort}>{t(`bankid.abort`)}</Link>
          </p>
        </div>
      )}
    </div>
  );
}
